import React from "react";
import "./AppConfirmDialog.css";

interface AppConfirmDialogProps {
  isOpen: boolean;
  title: string;
  message: React.ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
  isConfirming?: boolean;
  confirmingText?: string;
  /** Какая кнопка выполняет асинхронное действие — на ней показывается confirmingText во время isConfirming. По умолчанию — confirm. */
  confirmingButton?: "confirm" | "cancel";
  /** Закрывать ли диалог кликом по фону. По умолчанию true — выключайте для необратимых/массовых действий, где клик мимо не должен ничего запускать. */
  dismissOnOverlayClick?: boolean;
  "data-testid"?: string;
}

export const AppConfirmDialog: React.FC<AppConfirmDialogProps> = ({
  isOpen,
  title,
  message,
  onConfirm,
  onCancel,
  confirmText = "Удалить",
  cancelText = "Отмена",
  isConfirming = false,
  confirmingText,
  confirmingButton = "confirm",
  dismissOnOverlayClick = true,
  "data-testid": dataTestId = "confirm-dialog",
}) => {
  if (!isOpen) {
    return null;
  }

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (dismissOnOverlayClick && e.target === e.currentTarget) {
      onCancel();
    }
  };

  return (
    <div className="app-confirm-dialog-overlay" onClick={handleOverlayClick}>
      <div className="app-confirm-dialog" data-testid={dataTestId}>
        <h2 className="app-confirm-dialog__title">{title}</h2>
        <p className="app-confirm-dialog__message">{message}</p>
        <div className="app-confirm-dialog__actions">
          <button
            type="button"
            className="app-confirm-dialog__button app-confirm-dialog__button_secondary"
            onClick={onCancel}
            disabled={isConfirming}
            data-testid={`${dataTestId}-cancel`}
          >
            {isConfirming && confirmingButton === "cancel"
              ? (confirmingText ?? cancelText)
              : cancelText}
          </button>
          <button
            type="button"
            className="app-confirm-dialog__button app-confirm-dialog__button_primary"
            onClick={onConfirm}
            disabled={isConfirming}
            data-testid={`${dataTestId}-confirm`}
          >
            {isConfirming && confirmingButton === "confirm"
              ? (confirmingText ?? confirmText)
              : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AppConfirmDialog;
